/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 */
export var ADD = "add";
export var ADD_CLIP = "add-clip";
export var ADD_COLUMN_LEFT = "add-column-left";
export var ADD_COLUMN_RIGHT = "add-column-right";
export var ADD_LOCATION = "add-location";
export var ADD_ROW_BOTTOM = "add-row-bottom";
export var ADD_ROW_TOP = "add-row-top";
export var ADD_TO_ARTIFACT = "add-to-artifact";
export var ADD_TO_FOLDER = "add-to-folder";
export var AIRPLANE = "airplane";
export var ALIGN_CENTER = "align-center";
export var ALIGN_JUSTIFY = "align-justify";
export var ALIGN_LEFT = "align-left";
export var ALIGN_RIGHT = "align-right";
export var ALIGNMENT_BOTTOM = "alignment-bottom";
export var ALIGNMENT_HORIZONTAL_CENTER = "alignment-horizontal-center";
export var ALIGNMENT_LEFT = "alignment-left";
export var ALIGNMENT_RIGHT = "alignment-right";
export var ALIGNMENT_TOP = "alignment-top";
export var ALIGNMENT_VERTICAL_CENTER = "alignment-vertical-center";
export var ANNOTATION = "annotation";
export var ANTENNA = "antenna";
export var APP_HEADER = "app-header";
export var APPLICATION = "application";
export var APPLICATIONS = "applications";
export var ARCHIVE = "archive";
export var AREA_OF_INTEREST = "area-of-interest";
export var ARRAY = "array";
export var ARRAY_BOOLEAN = "array-boolean";
export var ARRAY_DATE = "array-date";
export var ARRAY_NUMERIC = "array-numeric";
export var ARRAY_STRING = "array-string";
export var ARRAY_TIMESTAMP = "array-timestamp";
export var ARROW_BOTTOM_LEFT = "arrow-bottom-left";
export var ARROW_BOTTOM_RIGHT = "arrow-bottom-right";
export var ARROW_DOWN = "arrow-down";
export var ARROW_LEFT = "arrow-left";
export var ARROW_RIGHT = "arrow-right";
export var ARROW_TOP_LEFT = "arrow-top-left";
export var ARROW_TOP_RIGHT = "arrow-top-right";
export var ARROW_UP = "arrow-up";
export var ARROWS_HORIZONTAL = "arrows-horizontal";
export var ARROWS_VERTICAL = "arrows-vertical";
export var ASTERISK = "asterisk";
export var AUTOMATIC_UPDATES = "automatic-updates";
export var BACKLINK = "backlink";
export var BADGE = "badge";
export var BAN_CIRCLE = "ban-circle";
export var BANK_ACCOUNT = "bank-account";
export var BARCODE = "barcode";
export var BLANK = "blank";
export var BLOCKED_PERSON = "blocked-person";
export var BOLD = "bold";
export var BOOK = "book";
export var BOOKMARK = "bookmark";
export var BOX = "box";
export var BRIEFCASE = "briefcase";
export var BRING_DATA = "bring-data";
export var BUGGY = "buggy";
export var BUILD = "build";
export var CALCULATOR = "calculator";
export var CALENDAR = "calendar";
export var CAMERA = "camera";
export var CARET_DOWN = "caret-down";
export var CARET_LEFT = "caret-left";
export var CARET_RIGHT = "caret-right";
export var CARET_UP = "caret-up";
export var CARGO_SHIP = "cargo-ship";
export var CELL_TOWER = "cell-tower";
export var CHANGES = "changes";
export var CHART = "chart";
export var CHAT = "chat";
export var CHEVRON_BACKWARD = "chevron-backward";
export var CHEVRON_DOWN = "chevron-down";
export var CHEVRON_FORWARD = "chevron-forward";
export var CHEVRON_LEFT = "chevron-left";
export var CHEVRON_RIGHT = "chevron-right";
export var CHEVRON_UP = "chevron-up";
export var CIRCLE = "circle";
export var CIRCLE_ARROW_DOWN = "circle-arrow-down";
export var CIRCLE_ARROW_LEFT = "circle-arrow-left";
export var CIRCLE_ARROW_RIGHT = "circle-arrow-right";
export var CIRCLE_ARROW_UP = "circle-arrow-up";
export var CITATION = "citation";
export var CLEAN = "clean";
export var CLIP = "clip";
export var CLIPBOARD = "clipboard";
export var CLOUD = "cloud";
export var CLOUD_DOWNLOAD = "cloud-download";
export var CLOUD_UPLOAD = "cloud-upload";
export var CODE = "code";
export var CODE_BLOCK = "code-block";
export var COG = "cog";
export var COLLAPSE_ALL = "collapse-all";
export var COLUMN_LAYOUT = "column-layout";
export var COMMENT = "comment";
export var COMPARISON = "comparison";
export var COMPASS = "compass";
export var COMPRESSED = "compressed";
export var CONFIRM = "confirm";
export var CONSOLE = "console";
export var CONTRAST = "contrast";
export var CONTROL = "control";
export var CREDIT_CARD = "credit-card";
export var CROSS = "cross";
export var CROWN = "crown";
export var CUBE = "cube";
export var CUBE_ADD = "cube-add";
export var CUBE_REMOVE = "cube-remove";
export var CURVED_RANGE_CHART = "curved-range-chart";
export var CUT = "cut";
export var CYCLE = "cycle";
export var DASHBOARD = "dashboard";
export var DATA_CONNECTION = "data-connection";
export var DATA_LINEAGE = "data-lineage";
export var DATABASE = "database";
export var DELETE = "delete";
export var DELTA = "delta";
export var DERIVE_COLUMN = "derive-column";
export var DESKTOP = "desktop";
export var DIAGNOSIS = "diagnosis";
export var DIAGRAM_TREE = "diagram-tree";
export var DIRECTION_LEFT = "direction-left";
export var DIRECTION_RIGHT = "direction-right";
export var DISABLE = "disable";
export var DOCUMENT = "document";
export var DOCUMENT_OPEN = "document-open";
export var DOCUMENT_SHARE = "document-share";
export var DOLLAR = "dollar";
export var DOT = "dot";
export var DOUBLE_CARET_HORIZONTAL = "double-caret-horizontal";
export var DOUBLE_CARET_VERTICAL = "double-caret-vertical";
export var DOUBLE_CHEVRON_DOWN = "double-chevron-down";
export var DOUBLE_CHEVRON_LEFT = "double-chevron-left";
export var DOUBLE_CHEVRON_RIGHT = "double-chevron-right";
export var DOUBLE_CHEVRON_UP = "double-chevron-up";
export var DOUGHNUT_CHART = "doughnut-chart";
export var DOWNLOAD = "download";
export var DRAG_HANDLE_HORIZONTAL = "drag-handle-horizontal";
export var DRAG_HANDLE_VERTICAL = "drag-handle-vertical";
export var DRAW = "draw";
export var DRAWER_LEFT = "drawer-left";
export var DRAWER_LEFT_FILLED = "drawer-left-filled";
export var DRAWER_RIGHT = "drawer-right";
export var DRAWER_RIGHT_FILLED = "drawer-right-filled";
export var DRIVE_TIME = "drive-time";
export var DUPLICATE = "duplicate";
export var EDIT = "edit";
export var EJECT = "eject";
export var EMOJI = "emoji";
export var ENDORSED = "endorsed";
export var ENVELOPE = "envelope";
export var EQUALS = "equals";
export var ERASER = "eraser";
export var ERROR = "error";
export var EURO = "euro";
export var EXCHANGE = "exchange";
export var EXCLUDE_ROW = "exclude-row";
export var EXPAND_ALL = "expand-all";
export var EXPORT = "export";
export var EYE_OFF = "eye-off";
export var EYE_ON = "eye-on";
export var EYE_OPEN = "eye-open";
export var FAST_BACKWARD = "fast-backward";
export var FAST_FORWARD = "fast-forward";
export var FEED = "feed";
export var FEED_SUBSCRIBED = "feed-subscribed";
export var FILM = "film";
export var FILTER = "filter";
export var FILTER_KEEP = "filter-keep";
export var FILTER_LIST = "filter-list";
export var FILTER_OPEN = "filter-open";
export var FILTER_REMOVE = "filter-remove";
export var FLAG = "flag";
export var FLAME = "flame";
export var FLASH = "flash";
export var FLOPPY_DISK = "floppy-disk";
export var FLOW_BRANCH = "flow-branch";
export var FLOW_END = "flow-end";
export var FLOW_LINEAR = "flow-linear";
export var FLOW_REVIEW = "flow-review";
export var FLOW_REVIEW_BRANCH = "flow-review-branch";
export var FLOWS = "flows";
export var FOLDER_CLOSE = "folder-close";
export var FOLDER_NEW = "folder-new";
export var FOLDER_OPEN = "folder-open";
export var FOLDER_SHARED = "folder-shared";
export var FOLDER_SHARED_OPEN = "folder-shared-open";
export var FOLLOWER = "follower";
export var FOLLOWING = "following";
export var FONT = "font";
export var FORK = "fork";
export var FORM = "form";
export var FULL_CIRCLE = "full-circle";
export var FULL_STACKED_CHART = "full-stacked-chart";
export var FULLSCREEN = "fullscreen";
export var FUNCTION = "function";
export var GANTT_CHART = "gantt-chart";
export var GEOFENCE = "geofence";
export var GEOLOCATION = "geolocation";
export var GEOSEARCH = "geosearch";
export var GIT_BRANCH = "git-branch";
export var GIT_COMMIT = "git-commit";
export var GIT_MERGE = "git-merge";
export var GIT_NEW_BRANCH = "git-new-branch";
export var GIT_PULL = "git-pull";
export var GIT_PUSH = "git-push";
export var GIT_REPO = "git-repo";
export var GLASS = "glass";
export var GLOBE = "globe";
export var GLOBE_NETWORK = "globe-network";
export var GRAPH = "graph";
export var GRAPH_REMOVE = "graph-remove";
export var GREATER_THAN = "greater-than";
export var GREATER_THAN_OR_EQUAL_TO = "greater-than-or-equal-to";
export var GRID = "grid";
export var GRID_VIEW = "grid-view";
export var GROUP_OBJECTS = "group-objects";
export var GROUPED_BAR_CHART = "grouped-bar-chart";
export var HAND = "hand";
export var HAND_DOWN = "hand-down";
export var HAND_LEFT = "hand-left";
export var HAND_RIGHT = "hand-right";
export var HAND_UP = "hand-up";
export var HAT = "hat";
export var HEADER = "header";
export var HEADER_ONE = "header-one";
export var HEADER_THREE = "header-three";
export var HEADER_TWO = "header-two";
export var HEADSET = "headset";
export var HEART = "heart";
export var HEART_BROKEN = "heart-broken";
export var HEAT_GRID = "heat-grid";
export var HEATMAP = "heatmap";
export var HELICOPTER = "helicopter";
export var HELP = "help";
export var HELPER_MANAGEMENT = "helper-management";
export var HIGH_PRIORITY = "high-priority";
export var HIGHLIGHT = "highlight";
export var HISTORY = "history";
export var HOME = "home";
export var HORIZONTAL_BAR_CHART = "horizontal-bar-chart";
export var HORIZONTAL_BAR_CHART_ASC = "horizontal-bar-chart-asc";
export var HORIZONTAL_BAR_CHART_DESC = "horizontal-bar-chart-desc";
export var HORIZONTAL_DISTRIBUTION = "horizontal-distribution";
export var HURRICANE = "hurricane";
export var ID_NUMBER = "id-number";
export var IMAGE_ROTATE_LEFT = "image-rotate-left";
export var IMAGE_ROTATE_RIGHT = "image-rotate-right";
export var IMPORT = "import";
export var INBOX = "inbox";
export var INBOX_FILTERED = "inbox-filtered";
export var INBOX_GEO = "inbox-geo";
export var INBOX_SEARCH = "inbox-search";
export var INBOX_UPDATE = "inbox-update";
export var INFO_SIGN = "info-sign";
export var INHERITANCE = "inheritance";
export var INHERITED_GROUP = "inherited-group";
export var INNER_JOIN = "inner-join";
export var INSERT = "insert";
export var INTERSECTION = "intersection";
export var IP_ADDRESS = "ip-address";
export var ISSUE = "issue";
export var ISSUE_CLOSED = "issue-closed";
export var ISSUE_NEW = "issue-new";
export var ITALIC = "italic";
export var JOIN_TABLE = "join-table";
export var KEY = "key";
export var KEY_BACKSPACE = "key-backspace";
export var KEY_COMMAND = "key-command";
export var KEY_CONTROL = "key-control";
export var KEY_DELETE = "key-delete";
export var KEY_ENTER = "key-enter";
export var KEY_ESCAPE = "key-escape";
export var KEY_OPTION = "key-option";
export var KEY_SHIFT = "key-shift";
export var KEY_TAB = "key-tab";
export var KNOWN_VEHICLE = "known-vehicle";
export var LAB_TEST = "lab-test";
export var LABEL = "label";
export var LAYER = "layer";
export var LAYER_OUTLINE = "layer-outline";
export var LAYERS = "layers";
export var LAYOUT = "layout";
export var LAYOUT_AUTO = "layout-auto";
export var LAYOUT_BALLOON = "layout-balloon";
export var LAYOUT_CIRCLE = "layout-circle";
export var LAYOUT_GRID = "layout-grid";
export var LAYOUT_GROUP_BY = "layout-group-by";
export var LAYOUT_HIERARCHY = "layout-hierarchy";
export var LAYOUT_LINEAR = "layout-linear";
export var LAYOUT_SKEW_GRID = "layout-skew-grid";
export var LAYOUT_SORTED_CLUSTERS = "layout-sorted-clusters";
export var LEARNING = "learning";
export var LEFT_JOIN = "left-join";
export var LESS_THAN = "less-than";
export var LESS_THAN_OR_EQUAL_TO = "less-than-or-equal-to";
export var LIFESAVER = "lifesaver";
export var LIGHTBULB = "lightbulb";
export var LIGHTNING = "lightning";
export var LINK = "link";
export var LIST = "list";
export var LIST_COLUMNS = "list-columns";
export var LIST_DETAIL_VIEW = "list-detail-view";
export var LOCATE = "locate";
export var LOCK = "lock";
export var LOG_IN = "log-in";
export var LOG_OUT = "log-out";
export var MANUAL = "manual";
export var MANUALLY_ENTERED_DATA = "manually-entered-data";
export var MANY_TO_MANY = "many-to-many";
export var MANY_TO_ONE = "many-to-one";
export var MAP = "map";
export var MAP_CREATE = "map-create";
export var MAP_MARKER = "map-marker";
export var MAXIMIZE = "maximize";
export var MEDIA = "media";
export var MENU = "menu";
export var MENU_CLOSED = "menu-closed";
export var MENU_OPEN = "menu-open";
export var MERGE_COLUMNS = "merge-columns";
export var MERGE_LINKS = "merge-links";
export var MINIMIZE = "minimize";
export var MINUS = "minus";
export var MOBILE_PHONE = "mobile-phone";
export var MOBILE_VIDEO = "mobile-video";
export var MODAL = "modal";
export var MODAL_FILLED = "modal-filled";
export var MOON = "moon";
export var MORE = "more";
export var MOUNTAIN = "mountain";
export var MOVE = "move";
export var MUGSHOT = "mugshot";
export var MULTI_SELECT = "multi-select";
export var MUSIC = "music";
export var NEST = "nest";
export var NEW_DRAWING = "new-drawing";
export var NEW_GRID_ITEM = "new-grid-item";
export var NEW_LAYER = "new-layer";
export var NEW_LAYERS = "new-layers";
export var NEW_LINK = "new-link";
export var NEW_OBJECT = "new-object";
export var NEW_PERSON = "new-person";
export var NEW_PRESCRIPTION = "new-prescription";
export var NEW_TEXT_BOX = "new-text-box";
export var NINJA = "ninja";
export var NOT_EQUAL_TO = "not-equal-to";
export var NOTIFICATIONS = "notifications";
export var NOTIFICATIONS_SNOOZE = "notifications-snooze";
export var NOTIFICATIONS_UPDATED = "notifications-updated";
export var NUMBERED_LIST = "numbered-list";
export var NUMERICAL = "numerical";
export var OFFICE = "office";
export var OFFLINE = "offline";
export var OIL_FIELD = "oil-field";
export var ONE_COLUMN = "one-column";
export var ONE_TO_MANY = "one-to-many";
export var ONE_TO_ONE = "one-to-one";
export var OUTDATED = "outdated";
export var PAGE_LAYOUT = "page-layout";
export var PANEL_STATS = "panel-stats";
export var PANEL_TABLE = "panel-table";
export var PAPERCLIP = "paperclip";
export var PARAGRAPH = "paragraph";
export var PATH = "path";
export var PATH_SEARCH = "path-search";
export var PAUSE = "pause";
export var PEOPLE = "people";
export var PERCENTAGE = "percentage";
export var PERSON = "person";
export var PHONE = "phone";
export var PIE_CHART = "pie-chart";
export var PIN = "pin";
export var PIVOT = "pivot";
export var PIVOT_TABLE = "pivot-table";
export var PLAY = "play";
export var PLUS = "plus";
export var POLYGON_FILTER = "polygon-filter";
export var POWER = "power";
export var PREDICTIVE_ANALYSIS = "predictive-analysis";
export var PRESCRIPTION = "prescription";
export var PRESENTATION = "presentation";
export var PRINT = "print";
export var PROJECTS = "projects";
export var PROPERTIES = "properties";
export var PROPERTY = "property";
export var PUBLISH_FUNCTION = "publish-function";
export var PULSE = "pulse";
export var RAIN = "rain";
export var RANDOM = "random";
export var RECORD = "record";
export var RECTANGLE = "rectangle";
export var REDO = "redo";
export var REFRESH = "refresh";
export var REGRESSION_CHART = "regression-chart";
export var REMOVE = "remove";
export var REMOVE_COLUMN = "remove-column";
export var REMOVE_COLUMN_LEFT = "remove-column-left";
export var REMOVE_COLUMN_RIGHT = "remove-column-right";
export var REMOVE_ROW_BOTTOM = "remove-row-bottom";
export var REMOVE_ROW_TOP = "remove-row-top";
export var REPEAT = "repeat";
export var RESET = "reset";
export var RESOLVE = "resolve";
export var RIG = "rig";
export var RIGHT_JOIN = "right-join";
export var RING = "ring";
export var ROCKET = "rocket";
export var ROCKET_SLANT = "rocket-slant";
export var ROTATE_DOCUMENT = "rotate-document";
export var ROTATE_PAGE = "rotate-page";
export var ROUTE = "route";
export var SATELLITE = "satellite";
export var SAVED = "saved";
export var SCATTER_PLOT = "scatter-plot";
export var SEARCH = "search";
export var SEARCH_AROUND = "search-around";
export var SEARCH_TEMPLATE = "search-template";
export var SEARCH_TEXT = "search-text";
export var SEGMENTED_CONTROL = "segmented-control";
export var SELECT = "select";
export var SELECTION = "selection";
export var SEND_MESSAGE = "send-message";
export var SEND_TO = "send-to";
export var SEND_TO_GRAPH = "send-to-graph";
export var SEND_TO_MAP = "send-to-map";
export var SERIES_ADD = "series-add";
export var SERIES_CONFIGURATION = "series-configuration";
export var SERIES_DERIVED = "series-derived";
export var SERIES_FILTERED = "series-filtered";
export var SERIES_SEARCH = "series-search";
export var SETTINGS = "settings";
export var SHAPES = "shapes";
export var SHARE = "share";
export var SHARED_FILTER = "shared-filter";
export var SHIELD = "shield";
export var SHIP = "ship";
export var SHOP = "shop";
export var SHOPPING_CART = "shopping-cart";
export var SIGNAL_SEARCH = "signal-search";
export var SIM_CARD = "sim-card";
export var SLASH = "slash";
export var SMALL_CROSS = "small-cross";
export var SMALL_MINUS = "small-minus";
export var SMALL_PLUS = "small-plus";
export var SMALL_SQUARE = "small-square";
export var SMALL_TICK = "small-tick";
export var SNOWFLAKE = "snowflake";
export var SOCIAL_MEDIA = "social-media";
export var SORT = "sort";
export var SORT_ALPHABETICAL = "sort-alphabetical";
export var SORT_ALPHABETICAL_DESC = "sort-alphabetical-desc";
export var SORT_ASC = "sort-asc";
export var SORT_DESC = "sort-desc";
export var SORT_NUMERICAL = "sort-numerical";
export var SORT_NUMERICAL_DESC = "sort-numerical-desc";
export var SPLIT_COLUMNS = "split-columns";
export var SQUARE = "square";
export var STACKED_CHART = "stacked-chart";
export var STADIUM_GEOMETRY = "stadium-geometry";
export var STAR = "star";
export var STAR_EMPTY = "star-empty";
export var STEP_BACKWARD = "step-backward";
export var STEP_CHART = "step-chart";
export var STEP_FORWARD = "step-forward";
export var STOP = "stop";
export var STOPWATCH = "stopwatch";
export var STRIKETHROUGH = "strikethrough";
export var STYLE = "style";
export var SWAP_HORIZONTAL = "swap-horizontal";
export var SWAP_VERTICAL = "swap-vertical";
export var SWITCH = "switch";
export var SYMBOL_CIRCLE = "symbol-circle";
export var SYMBOL_CROSS = "symbol-cross";
export var SYMBOL_DIAMOND = "symbol-diamond";
export var SYMBOL_RECTANGLE = "symbol-rectangle";
export var SYMBOL_SQUARE = "symbol-square";
export var SYMBOL_TRIANGLE_DOWN = "symbol-triangle-down";
export var SYMBOL_TRIANGLE_UP = "symbol-triangle-up";
export var SYRINGE = "syringe";
export var TAG = "tag";
export var TAKE_ACTION = "take-action";
export var TANK = "tank";
export var TARGET = "target";
export var TAXI = "taxi";
export var TEMPERATURE = "temperature";
export var TEXT_HIGHLIGHT = "text-highlight";
export var TH = "th";
export var TH_DERIVED = "th-derived";
export var TH_DISCONNECT = "th-disconnect";
export var TH_FILTERED = "th-filtered";
export var TH_LIST = "th-list";
export var THIRD_PARTY = "third-party";
export var THUMBS_DOWN = "thumbs-down";
export var THUMBS_UP = "thumbs-up";
export var TICK = "tick";
export var TICK_CIRCLE = "tick-circle";
export var TIME = "time";
export var TIMELINE_AREA_CHART = "timeline-area-chart";
export var TIMELINE_BAR_CHART = "timeline-bar-chart";
export var TIMELINE_EVENTS = "timeline-events";
export var TIMELINE_LINE_CHART = "timeline-line-chart";
export var TINT = "tint";
export var TORCH = "torch";
export var TRACTOR = "tractor";
export var TRAIN = "train";
export var TRANSLATE = "translate";
export var TRASH = "trash";
export var TREE = "tree";
export var TRENDING_DOWN = "trending-down";
export var TRENDING_UP = "trending-up";
export var TRUCK = "truck";
export var TWO_COLUMNS = "two-columns";
export var UNARCHIVE = "unarchive";
export var UNDERLINE = "underline";
export var UNDO = "undo";
export var UNGROUP_OBJECTS = "ungroup-objects";
export var UNKNOWN_VEHICLE = "unknown-vehicle";
export var UNLOCK = "unlock";
export var UNPIN = "unpin";
export var UNRESOLVE = "unresolve";
export var UPDATED = "updated";
export var UPLOAD = "upload";
export var USER = "user";
export var VARIABLE = "variable";
export var VERTICAL_BAR_CHART_ASC = "vertical-bar-chart-asc";
export var VERTICAL_BAR_CHART_DESC = "vertical-bar-chart-desc";
export var VERTICAL_DISTRIBUTION = "vertical-distribution";
export var VIDEO = "video";
export var VIRUS = "virus";
export var VOLUME_DOWN = "volume-down";
export var VOLUME_OFF = "volume-off";
export var VOLUME_UP = "volume-up";
export var WALK = "walk";
export var WARNING_SIGN = "warning-sign";
export var WATERFALL_CHART = "waterfall-chart";
export var WAVES = "waves";
export var WIDGET = "widget";
export var WIDGET_BUTTON = "widget-button";
export var WIDGET_FOOTER = "widget-footer";
export var WIDGET_HEADER = "widget-header";
export var WIND = "wind";
export var WRENCH = "wrench";
export var ZOOM_IN = "zoom-in";
export var ZOOM_OUT = "zoom-out";
export var ZOOM_TO_FIT = "zoom-to-fit";
//# sourceMappingURL=iconNames.js.map